import { postData } from './api';
import { baseUrl } from '../config';

export const postGuestLogin = (data) => postData(`${baseUrl}/api/v2/guest-login`, data);

export const postConfirmGuestLogin = (data) =>
  postData(`${baseUrl}/api/v2/guest-login/confirm`, data);

export const postResendSmsCode = (data) => postData(`${baseUrl}/api/v2/guest-login/resend`, data);
